import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import './styles/app.css';
import { App } from './App.js';
import { Overlay } from './pages/Overlay.js';

const root = createRoot(document.getElementById('root')!);

/**
 * The overlay is a separate world: no site chrome, transparent background, and
 * mounted before anything else can paint a dark page behind it. OBS composites
 * it over gameplay, so a single opaque pixel is a bug.
 */
const isOverlay = location.pathname.startsWith('/overlay');

if (isOverlay) {
  document.documentElement.classList.add('overlay-mode');
  root.render(
    <StrictMode>
      <Overlay />
    </StrictMode>,
  );
} else {
  root.render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}
